import VueRouter from 'vue-router';
import { parseJson } from '../TypesHelper';
import { DeepLinkData } from './DeepLinkData';
import { DeepLinkTypes, OpeningDeepLinkParams } from './types';

import {
    actorParsers,
    parsers,
    unknowDeepLink
} from "./parsers";

/**
 * Parsing deepLink from string to object with type
 * @param str
 */
const parseDeepLink = (str: string) => {
    const link = decodeURI(str);
    const url = new URL(link);
    const params = parseJson(url.searchParams.get("params"));

    //actors
    if (url.protocol === "actor:") {
        return actorParsers[url.pathname](url, params);
    }

    if (parsers[url.protocol]) {
        return parsers[url.protocol](url, params) ?? unknowDeepLink();
    }

    return unknowDeepLink();
}

const openDeepLink = ({deepLink, backend, eventId}: OpeningDeepLinkParams, router: VueRouter) => {

    //for eventID
    if (eventId) {
        if (deepLink.type == DeepLinkTypes.event) {
            router.push({
                name: 'Home', params: {
                    backend: backend,
                    eventId: eventId,
                }
            });
        }

        if (deepLink.type == DeepLinkTypes.meeting) {
            router.push({
                name: 'ViewMeeting', params: {
                    backend: backend,
                    eventId: eventId,
                    id: (deepLink.data! as DeepLinkData).id
                }
            });
        }

        if (deepLink.type == DeepLinkTypes.session) {
            router.push({
                name: 'ViewSession', params: {
                    backend: backend,
                    eventId: eventId,
                    id: (deepLink.data! as DeepLinkData).id
                }
            });
        }

        if (deepLink.type == DeepLinkTypes.htmlPage) {
            router.push({
                name: 'Info', params: {
                    backend: backend,
                    eventId: eventId,
                    objectId: (deepLink.data! as DeepLinkData).id
                }
            });
        }

        if (deepLink.type == DeepLinkTypes.catalog) {
            router.push({
                name: 'Partner', params: {
                    backend: backend,
                    eventId: eventId,
                    id: (deepLink.data! as DeepLinkData).id,
                    schemaId: deepLink.data?.schemaId || ""
                }
            });
        }
    }

    if (deepLink.type == DeepLinkTypes.url) {
        window.open((deepLink.data! as DeepLinkData).url);
    }
}

export {parseDeepLink, openDeepLink };
